import {
  GetCountryLookUpType,
  GetYearlyInvoiceAuditType,
  InvoiceReportProps,
  MopnthlyInvoiceAuditProps,
  GetMonthlyInvoiceAuditType,
  ExportReportListParams,
  invoicesSummary,
} from '../../../../types/Invoicing/InvoiceReport/yearlyInvoiceAudittype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, invoiceReportListApiConfig } from '../../apiList'

const getInvoicesYearlyReportList = async (
  props: InvoiceReportProps,
): Promise<GetYearlyInvoiceAuditType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceReportListApiConfig.yearlyInvoiceAudit,
    method: AllowedHttpMethods.get,
    params: {
      country: props.country,
      fromDate: props.fromDate,
      intrnalOrNot: props.intrnalOrNot,
      multiText: props.multiText,
      status: props.status,
      toDate: props.toDate,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getCountryLookupList = async (): Promise<GetCountryLookUpType[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceReportListApiConfig.getCountryLookup,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getMonthlyInvoiceAudit = async (
  props: MopnthlyInvoiceAuditProps,
): Promise<GetMonthlyInvoiceAuditType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceReportListApiConfig.mopnthlyInvoiceAudit,
    method: AllowedHttpMethods.get,
    params: {
      country: props.country,
      invoiceStatus: props.invoiceStatus,
      monthName: props.monthName,
      year: props.year,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const projectFinancialList = async (
  props: ExportReportListParams,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceReportListApiConfig.projectFinancialList,
    method: AllowedHttpMethods.get,
    params: {
      fromDate: props.fromDate ?? '',
      toDate: props.toDate ?? '',
      invoiceDateSelection: props.invoiceDateSelection ?? '',
      token: localStorage.getItem('token') ?? '',
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getInvoiceSummary = async (
  invoiceId: number,
): Promise<invoicesSummary> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceReportListApiConfig.getInvoiceSummary,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const invoicesReportListApi = {
  getInvoicesYearlyReportList,
  getCountryLookupList,
  getMonthlyInvoiceAudit,
  projectFinancialList,
  getInvoiceSummary,
}

export default invoicesReportListApi
